import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component for showing a single form validation error message.
 *
 * @params see propTypes
 * @returns {JSX.Element|null}
 * @component
 */
const ValidationErrorMessage = ({ error, input }) => {
  return (
    <div
      className="text-rhubarb-triangle fw-normal mt-2"
      data-error={input}>
      {error.message}
    </div>
  );
};

ValidationErrorMessage.propTypes = {
  /**
   * A react hook form error object, containing an error for a single form input.
   */
  error: PropTypes.object.isRequired,
  input: PropTypes.string
};

export default ValidationErrorMessage;
